import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { blue } from './colorUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Spin', 'blueTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      [`${componentCls}-dot-item`]: {
        background: `${blue[500]} !important`,
        boxShadow: `0 0 6px ${blue[500]}80`,
      },

      [`${componentCls}-text`]: {
        color: `${blue[300]} !important`,
      },
    },
  }
})
